import CreateAccountButton from "@components/CreateAccountButton/CreateAccountButton";
import ServiceItem from "@components/Home/ServiceItem/ServiceItem";
import { Stack, Typography } from "@mui/material";
import { serviceItems } from "@pages/home/Home.constants";
import React from "react";
import { useTranslation } from "react-i18next";

const OurServices = ({ isService, user }) => {
  const { t } = useTranslation();
  return (
    <Stack className="our-service">
      <Typography className="sub-title">
        {t("home.service_sub_title")}
      </Typography>
      <Typography className="service-title">
        {t("home.service_title")}
      </Typography>
      <div className="services-card row justify-content-center g-3 px-0 ">
        {serviceItems.map((item) => {
          return (
            <div
              className={
                item.imgService
                  ? "col-xl-8 col-lg-9 col-md-12"
                  : "col-xl-4 col-lg-6 col-md-6"
              }>
              <ServiceItem
                isWithImg={item.imgService ? true : false}
                title={item.title}
                description={item.description}
                icon={item.icon}
                imgService={item.imgService}
                isService={isService}
              />
            </div>
          );
        })}
      </div>
      <Typography className="title_service2" style={{ paddingTop: "2rem" }}>
        {t("home.service_title1")}
      </Typography>
      <Typography className="title_service2">
        {t("home.service_title2")}
      </Typography>
      {!user && <CreateAccountButton />}
      <Typography className="txt_service_adjec">
        {t("home.txt_service_adjec")}
      </Typography>
    </Stack>
  );
};

export default OurServices;
